<template>
<div class="container-fluid" >
  <button   @click="$emit('close')" type="button"  class="btn btn-secondary ml-1 mb-1">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A PARAMETRI RICERCA
  </button>    
  
  <button   @click="exportToCSV()" type="button"  class="btn btn-primary ml-2 mb-1">
    <i style="color:white" class="fas fa-file-export mr-2"></i>
    ESPORTA IN CSV
  </button>    
  


<div class="row">
<div class="col">


<div class="table-wrapper-scroll-y my-custom-scrollbar" id="table_div">
<table id='my-table' class="table table table-sm table-bordered mb-0">
  <thead >
    <tr class="table-primary">
    
      <th scope="col">BRAND</th>
      <th class="text-right" scope="col">QUANTITA' VENDUTA</th>
      <th class="text-right" scope="col">VALORE VENDUTO €</th>      
               
    </tr>
  </thead>
  <tbody>
    <tr :style="{color: item.rowType == 1  ? 'red' : 'black'}"   data-toggle="tooltip" title="" class="pointer"  v-for="(item, index) in items" :key="index">

     <!-- <td class="text-nowrap">{{item.store}} </td> -->
      <td class="text-nowrap">{{item.brand}} </td>        
      <td class="text-right" >{{fmt2(item.total1)}}</td>          
      <td class="text-right">{{fmt1(item.total2)}} </td>
        
    </tr> 
  </tbody>
  
  <tfoot>
    <tr :style="{color: item.rowType == 1  ? 'red' : 'black'  }"   class="pointer" v-for="(item, index) in getTotals" :key="index"> 
      <td>TOTALE {{ item.rowType == 0 ? 'VENDUTO' : 'RESO' }}</td>      
      
      <td class="text-right" >{{fmt2(item.total1)}}</td>    
      <td class="text-right">{{fmt1(item.total2)}}</td>
    </tr>   
  </tfoot>    
</table>

</div>
</div>
</div>


</div>

</template>
<script>

import { mapGetters }    from 'vuex';
import fmt               from '@/components/mixins/fmt'

export default {

  mixins     : [fmt],
  components : {},
  props      : ['items'],

  data() {
    return {
       
    };
  },

  computed :{
    ...mapGetters(['company']),
    getTotals :function() {
     
     const total = {total1_qty : 0, total1_val : 0.00, /*total2_qty : 0 , total2_val : 0.00*/}         
     this.items.forEach(item => {
         if(item.rowType== 0) 
         {
         total.total1_qty  += item.total1
         total.total1_val  += item.total2
         }
         else
         {
          total.total2_qty  += item.total1
          total.total2_val  += item.total2
         }       

         
     })
     const totals = []
     totals.push({"rowType":0,"total1":total.total1_qty,"total2":total.total1_val})
     //totals.push({"rowType":1,"total1":total.total2_qty,"total2":total.total2_val})
     console.log(totals)
     return totals
   },
  
   
  },
  
  
  methods: {

  
    exportToCSV()
    {
      const sep = ','
      const td  = '"'
      const header =  ['BRAND',
                      'QUANTITA\' VENDUTA',
                      'VALORE VENDUTO €'
                      
                      ]

      let index = 0  
      header.forEach(item=>{
        header[index] = td + item + td
        index++
      })
      
      const data = this.items
    
      const lf = '\r\n'

      let csvData = "data:text/csv;charset=utf-8," 
      csvData += header.join(sep) + lf
      let row = ''
    
      data.forEach(item => {
        
        const total = this.fmt1(item.total2).replace(".","")
        row += td + item.brand + td + sep
        row += td + item.total1 + td + sep
        row += td + total +  td + sep
        
        csvData += row + lf
        row = ''


       
      })
      const encodedUri = encodeURI(csvData);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "AnalisiVenditePerBrand.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv".

    },


  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 500px;
overflow   : auto;
}
.pointer:hover
{
  background-color: rgb(214, 225, 226);
  color: white;
  cursor: pointer;
}
.list-group-item
{
  font-size: 18px;
}

.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    

 }

.table tfoot tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 22px;
    font-weight  : bold;
    background   : #e9fce9;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

.table-wrapper-scroll-y {
display: block;
}

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

.card-header
{
  height: 45px;
}

</style>